import tool_app from './tool_app'
import {Auth,} from 'aws-amplify'
import awsmobile from '../aws-exports'

const AWS = require('aws-sdk')

function lg (...args) {
  tool_app.lg('tool_aws] ', ...args);
}
const tool_aws = {
  getCurrentSession: async function() {
    let session = await Auth.currentSession();
    return session;
  },
  getAdminCognito: async () => {
    let session = await Auth.currentSession();

      // AWS.config.region
      AWS.config.update({region: awsmobile.aws_cognito_region});

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        sessionToken: session.idToken.jwtToken,
        IdentityPoolId: awsmobile.aws_cognito_identity_pool_id,
        RoleArn: 'arn:aws:iam::679276326488:role/myvaletres20190826-masterenv-20190826162209-adminRole',
        Logins: {
          // 'cognito-idp.ap-northeast-2.amazonaws.com/ap-northeast-2_OJNRmynJH': result.getIdToken().getJwtToken()
          'cognito-idp.ap-northeast-2.amazonaws.com/ap-northeast-2_SVStKVyAb': session.idToken.jwtToken

        }
      });

      AWS.config.credentials.get(function (err) {
        if (err) {
          alert(err);
        }
      });
    return new AWS.CognitoIdentityServiceProvider({
        region: awsmobile.aws_cognito_region,
        sessionToken: session.idToken.jwtToken,
      });


      // return new Promise(function (resolve, reject) {
      //   Auth.currentSession()
      //     .then(data => {
      //       lg('api 1 data: ', data);
      //
      //       // AWS.config.region
      //       AWS.config.update({region: awsmobile.aws_cognito_region});
      //
      //       AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      //         sessionToken: data.idToken.jwtToken,
      //         IdentityPoolId: awsmobile.aws_cognito_identity_pool_id,
      //         Logins: {
      //           // 'cognito-idp.ap-northeast-2.amazonaws.com/ap-northeast-2_OJNRmynJH': result.getIdToken().getJwtToken()
      //           'cognito-idp.ap-northeast-2.amazonaws.com/ap-northeast-2_OJNRmynJH': data.idToken.jwtToken
      //
      //         }
      //       });
      //
      //       AWS.config.credentials.get(function (err) {
      //         if (err) {
      //           alert(err);
      //         }
      //       });
      //       const identity = new AWS.CognitoIdentityServiceProvider({
      //         region: awsmobile.aws_cognito_region,
      //         sessionToken: data.idToken.jwtToken,
      //       });
      //       resolve(identity);
      //
      //       // var params = {
      //       //   UserPoolId: awsmobile.aws_user_pools_id,
      //       //   // AttributesToGet: [
      //       //   //   'STRING_VALUE',
      //       //   //   /* more items */
      //       //   // ],
      //       //   // Filter: 'STRING_VALUE',
      //       //   // Limit: 'NUMBER_VALUE',
      //       //   // PaginationToken: 'STRING_VALUE'
      //       // };
      //       // identity.listUsers(params, function (err, data) {
      //       //   if (err) console.log(err, err.stack); // an error occurred
      //       //   else console.log(data);           // successful response
      //       // });
      //     })
      //     .catch(err => {
      //       tool_app.ex(err);
      //     })
      //     .finally(() => {
      //     });
      // });
  }
}

export default tool_aws;
